import axios from "axios";
import authHeader from '../../../authheader'

const PLSRENEWALURL = process.env.REACT_APP_APIURL + "/api/IndividualPlsRenewal";

const getLicenseStatus = (renewalId) => {
    return axios.get(`${PLSRENEWALURL}/licensestatus`, { headers: authHeader(), params: { renewalId } });
}
const postLicenseStatus = (renewalId, renewingToId) => {
    return axios.post(`${PLSRENEWALURL}/licensestatus`, null, { headers: authHeader(), params: {renewalId, renewingToId} });
}
export default {
    getLicenseStatus,
    postLicenseStatus
}